import { Tv, Clapperboard, Trophy, Youtube, Heart, Smartphone, IndianRupee, Landmark, Tag, LayoutGrid } from "lucide-react";

// Each launch category gets a distinct icon + accent colour so the feed scans fast.
export const CATEGORY_META = {
  "Reality TV & Pop Culture": { Icon: Tv, color: "#C026D3" },
  "Bollywood & OTT": { Icon: Clapperboard, color: "#DC2626" },
  "Cricket & Sports": { Icon: Trophy, color: "#16A34A" },
  "Influencers & Internet": { Icon: Youtube, color: "#EA580C" },
  "Dating & Gen Z": { Icon: Heart, color: "#EC4899" },
  "Tech & Culture": { Icon: Smartphone, color: "#4F46E5" },
  "Money & Life": { Icon: IndianRupee, color: "#0D9488" },
  "Politics": { Icon: Landmark, color: "#0EA5E9" },
  "All": { Icon: LayoutGrid, color: "#64748B" },
};

export const getCategoryMeta = (name) => CATEGORY_META[name] || { Icon: Tag, color: "#64748B" };

export function CategoryBadge({ category, className = "" }) {
  const { Icon, color } = getCategoryMeta(category);
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[11px] font-semibold tracking-wider uppercase px-2.5 py-1 rounded-full ${className}`}
      style={{ color, backgroundColor: `${color}1a` }}
      data-testid="category-badge"
    >
      <Icon className="w-3.5 h-3.5" strokeWidth={2.4} />
      {category}
    </span>
  );
}
